import { defineComponent as _defineComponent } from 'vue'
import Dialog from "primevue/dialog";
import {StakingAction} from "@/components/staking/StakingAction";
import {useConfigurationStore} from "@/store/configuration.store";
import {useUserStore} from "@/store/user.store";
import PercentsView from "@/components/commons/PercentsView.vue";
import AmountView from "@/components/commons/AmountView.vue";
import LoginPopUp from "@/components/layout/loginPopup/LoginPopUp.vue";
import {Field, Form} from "vee-validate";import C4EIcon from "@/components/commons/C4EIcon.vue";
import StakeManagementIcon from "@/components/commons/StakeManagementIcon.vue";
import {computed, onUnmounted, ref, watch} from "vue";
import {object, setLocale, string} from "yup";
import i18n from "@/plugins/i18n";
import {YupSequentialStringSchema} from "@/utils/yup-utils";
import {BigDecimal, divideBigInts} from "@/models/store/big.decimal";
import {LoyaltyDropPoolConfig} from "@/models/store/loyaltyDrop";
import InfoMessage from "@/components/commons/InfoMessage.vue";
import CoinAmount from "@/components/commons/CoinAmount.vue";
import {Coin} from "@/models/store/common";


import dataService from "@/services/data.service";
import {formatBigNumberLocalized} from "@/utils/locale-number-formatter";
import {RedelegationDirection} from "@/components/staking/StakingRedelegate";
import {calculateApr, calculateReward} from "@/components/loyaltyDrop/LoialtyDropUtil";

// const commissionForOperation = computed(() => {
//   return (Number(amount.value)/100) * Number(getPercents(props.validator.commission.rate)) || 0;
// });



export default /*#__PURE__*/_defineComponent({
  __name: 'LoyaltyDropPopup',
  props: {
    visible: { type: Boolean, required: true },
    boost: { type: Object, required: true }
  },
  emits: ['close', 'success'],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();


const props = __props;
const emit = __emit;


const loginPopupStatus = ref(false);
document.body.style.overflow = "hidden";
onUnmounted(() => {
  document.body.style.overflow = "auto";
});

const fee = ref(0);
const reserveCoins = ref(true);
const stakingAction = ref<StakingAction>(StakingAction.DELEGATE);

const canModify = computed<boolean>(() => {
  return useUserStore().isLoggedIn && useUserStore().connectionInfo.modifiable;
});

const poolUsage = computed(()=>{
  return calculatePoolUsageTokens(props.boost);
});

const percentagePoolUsage = computed(()=>{
  return calculatePercentagePoolUsage(props.boost);
});

const amount = ref<number>(0);
const showReserveCheckbox = ref(false);
const reservedCoins = useConfigurationStore().config.getConvertedAmount(useConfigurationStore().config.getReservedCoinsAmount());
setLocale({
  mixed: {
    defined: i18n.global.t('STAKING_VIEW.STAKING_POPUP.AMOUNT.REQUIRED'),
  }
});

const baseSchema = object().shape({
  redelegateValidator: object().nullable().test('validator', i18n.global.t('STAKING_VIEW.STAKING_POPUP.VALIDATOR.REQUIRED'), (value: any) => {
    return stakingAction.value === StakingAction.REDELEGATE ? !!value : true;
  }),
  amount: YupSequentialStringSchema([string().defined(),
    string().test('not-empty', i18n.global.t('STAKING_VIEW.STAKING_POPUP.AMOUNT.REQUIRED'), (value: string | undefined) => {
      return value ? value.length > 0 : false;
    }),
    string().matches(/^\d*(\.\d{0,6})?$/gm, i18n.global.t('STAKING_VIEW.STAKING_POPUP.AMOUNT.NUMBER', {decimal: useConfigurationStore().config.getViewDenomDecimals()})),
    string().test('delgation-moreThan', i18n.global.t('STAKING_VIEW.STAKING_POPUP.AMOUNT.MIN'), moreThan),
    string().test('delgation-lessThan', () => i18n.global.t('STAKING_VIEW.STAKING_POPUP.AMOUNT.MAX', {max: maxAmountMessageData()}), lessThanOrEqualTo)
  ])
});


function checkValue(value: string | undefined, check: (value: string) => boolean): boolean {
  if (!value) {
    return false;
  }
  try {
    return check(value);
  } catch (err) {
    return false;
  }
}

function moreThan(value: string | undefined): boolean {
  return checkValue(value, (value: string) => (new BigDecimal(value)).isBiggerThan(0));
}

async function action() {
  await dataService.onCreateVestingPoolLoyaltyDrop("ld-" + Math.floor(Math.random() * 100000), amount.value,
    props.boost.epochPeriod * props.boost.epochNumber / 1000, props.boost.vestingType, () => {
      emit('close');
    });
}

watch(reserveCoins, (next, prev) => {
  if (next) {
    amount.value -= Number(reservedCoins);
  } else {
    amount.value += Number(reservedCoins);
  }
});

watch(stakingAction, (next, prev) => {
  amount.value = 0;
  showReserveCheckbox.value = false;
});

function getMax() {

  const spendables = useUserStore().getSpendableBalance;
  let retValue = Number(useConfigurationStore().config.getConvertedAmount(spendables ? spendables : 0)) - Number(reservedCoins);
  if (retValue < 0) {
    retValue = 0;
  }
  const remainingTokens = Number(useConfigurationStore().config.getConvertedAmount(props.boost.baseTokens.amount - props.boost.usedTokens.amount - props.boost.reservedTokens.amount));
  if (remainingTokens < retValue) {
    retValue = remainingTokens;
  }
  console.log('GetMax: remainingTokens=' + remainingTokens + ' retValue=' + retValue);
  return retValue;
}


const amountToPass = computed(() => {
  let coins = [];
  coins.push(
    {amount: useUserStore().getSpendableBalance || 0, header: i18n.global.t('BOOST.POPUP.SPENDABLE')});
  return coins;
});

function calculatePoolUsageTokens(data: LoyaltyDropPoolConfig){
  return new Coin(data.reservedTokens.amount, data.reservedTokens.denom).add(data.usedTokens);
}

function calculatePercentagePoolUsage(data: LoyaltyDropPoolConfig): BigDecimal {
  return divideBigInts(data.reservedTokens.amount + data.usedTokens.amount, data.baseTokens.amount);
}

function msToDays(milliseconds:  number) {
  return Math.floor(milliseconds / (1000 * 60 * 60 * 24));
}

function maxAmountMessageData(): string {
  const maxAmount = getMax();
  return formatBigNumberLocalized(maxAmount.toFixed(useConfigurationStore().config.getViewDenomDecimals()));
}

function lessThanOrEqualTo(value: string | undefined): boolean {
  return checkValue(value, (value: string) => {
    const factor = useConfigurationStore().config.getViewDenomConversionFactor();
    const maxAmount = getMax();
    return (new BigDecimal(maxAmount)).multiply(factor).isBiggerThanOrEqualTo(new BigDecimal(value).multiply(factor));
  });
}


const __returned__ = { props, emit, loginPopupStatus, fee, reserveCoins, stakingAction, canModify, poolUsage, percentagePoolUsage, amount, showReserveCheckbox, reservedCoins, baseSchema, checkValue, moreThan, action, getMax, amountToPass, calculatePoolUsageTokens, calculatePercentagePoolUsage, msToDays, maxAmountMessageData, lessThanOrEqualTo, get Dialog() { return Dialog }, get useConfigurationStore() { return useConfigurationStore }, get useUserStore() { return useUserStore }, PercentsView, AmountView, LoginPopUp, get Field() { return Field }, get Form() { return Form }, C4EIcon, StakeManagementIcon, InfoMessage, CoinAmount, get calculateApr() { return calculateApr }, get calculateReward() { return calculateReward } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})